import { HttpClient } from '@angular/common/http';
import { Injectable, Injector, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { StockPickListListing, StockPickListSummary, StockPickLstDetailsSummary } from '~/models/modules/pickList';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class PickListService extends ApiServiceBase {
  pickListAdded: EventEmitter<any> = new EventEmitter();
  constructor(injector: Injector, private http: HttpClient){
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  createPickList(model: any){
    return this.client.post(this._url(), model);
  }

  getPickList(paramsObj?: any, model?: any){
    paramsObj = paramsObj || {};
        paramsObj.view = 'summary';
        let params = createHttpParams(paramsObj);

        return this.http
            .post<StockPickListSummary[]>(this._url(`/grid-data`), model, {
                params,
                observe: 'response',
            })
            .pipe(map(augmentPaging));
  }
  getOpenPicklistGridDataBySite(paramsObj?: any, model?: any){
    paramsObj = paramsObj || {};
        paramsObj.view = 'summary';
        let params = createHttpParams(paramsObj);

        return this.http
            .post<StockPickListSummary[]>(this._url(`/site/${model.SiteId}/open-picklist-grid-data`), model, {
                params,
                observe: 'response',
            })
            .pipe(map(augmentPaging));
  }


  getPickListById(id: number){
    return this.http.get<StockPickListSummary>(this._url(`/${id}`));
  }

  updatePickList(id: number, model: any){
    return this.client.put(this._url(`/${id}`), model);
  }

  getPickListBySiteId(siteId: number){
    return this.http.get<StockPickListListing[]>(this._url(`/GetPickListBySiteId/${siteId}`));
  }
  getOpenPickListBySiteId(siteId: number, paramsObj?: any){
    if (!siteId) {
      siteId = 0;
    }
    let params = createHttpParams(paramsObj);
    return this.http.get<any>(this._url(`/GetOpenPickListBySiteId/${siteId}`), { params, observe: 'response' });
  }

  batchClose(ids: number[]) {
    return this.client.put(this._url(`/batch-close`), ids);
  }
  batchOpen(ids: number[]) {
    return this.client.put(this._url(`/batch-open`), ids);
  }


  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/PickList${v}`);
  }
}
